export default "__VITE_ASSET__87292516__"